module.exports = __webpack_public_path__ + "static/img/img-finance-sharinglist-fail.622c513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finance/sharinglist/img-finance-sharinglist-fail.png
// module id = ykzZ
// module chunks = 1